import { useNavigate, useLocation } from 'react-router-dom';
import './StepIndicator.css';

const StepIndicator = ({ 
  totalSteps, 
  currentStep, 
  validateStep, 
  onValidationFail,
  basePath = '/onboarding' 
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const stepItems = Array.from({ length: totalSteps }, (_, index) => index + 1);
  
  // Determine the current step number from the URL path
  const getStepFromPath = (pathname) => {
    const match = pathname.match(/step-(\d+)/);
    if (match) return parseInt(match[1], 10);
    if (pathname.includes('/welcome')) return 0;
    return 1;
  };
  
  // Use the currentStep prop if provided, otherwise extract from URL
  const pathStep = currentStep !== undefined ? currentStep : getStepFromPath(location.pathname);
  
  const handleStepClick = async (clickedStepNumber) => {
    // Only allow navigation to previous steps
    if (clickedStepNumber >= pathStep) {
      return;
    }
    
    const targetStep = clickedStepNumber === 0 ? 'welcome' : `step-${clickedStepNumber}`;
    const params = new URLSearchParams(location.search);
    navigate(`${basePath}/${targetStep}?${params.toString()}`);
  };

  return (
    <div className="onboarding-step-indicator" aria-label={`Onboarding steps ${totalSteps} total`}>
      {stepItems.map((stepNumber, index) => {
        // Step number 1 in array corresponds to stepNumber 1
        // Active dots are all steps up to and including the current step
        const isActiveDot = index < pathStep;
        const isCurrentDot = index === pathStep - 1;
        const isActiveLine = index < pathStep - 1;
        
        return (
          <div key={stepNumber} className="onboarding-step-indicator__item">
            <button
              type="button"
              className={`onboarding-step-indicator__dot ${isActiveDot || isCurrentDot ? 'is-active' : ''} onboarding-step-indicator__dot--clickable`}
              onClick={() => handleStepClick(stepNumber)}
              aria-label={`Go to step ${stepNumber}`}
            >
              {stepNumber}
            </button>
            {index < stepItems.length - 1 ? (
              <div className={`onboarding-step-indicator__line ${isActiveLine ? 'is-active' : ''}`} />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator;

